import "./MarketEntry.module.css";
import Header from "@/reusable_sections/Header";
import ExpansionStrategy from "./sections/ExpansionStrategy";
import StrategicSuccessStories from "./sections/StrategicSuccessStories";
import InquireAboutExpansion from "./sections/InquireAboutExpansion";
import SiteFooter from "@/reusable_sections/Footer";
export default function MarketEntryPage() {
  return <div>
      <Header />
      <ExpansionStrategy />
      <StrategicSuccessStories />
      <InquireAboutExpansion />
      <SiteFooter />
    </div>;
}